var map = {
	"./social-500px.svg": 134,
	"./social-dribbble.svg": 135,
	"./social-facebook.svg": 136,
	"./social-github.svg": 137,
	"./social-google.svg": 138,
	"./social-instagram.svg": 139,
	"./social-odnoklassniki.svg": 140,
	"./social-reddit.svg": 141,
	"./social-stackoverflow.svg": 142,
	"./social-steam.svg": 143,
	"./social-twitch.svg": 144,
	"./social-twitter.svg": 145,
	"./social-vkontakte.svg": 146,
	"./social-windows.svg": 147,
	"./social-yahoo.svg": 148
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 133
// module chunks = 0